const supportedPreviousPayrollProviders = [
    "BrightPay",
    "Fourth"
];

export default supportedPreviousPayrollProviders;